import React from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import Form from "../../components/common/Forms/Form";

const ResultadoDeSorteiosForm = (props) => {
  const {
    form,
    buscarResultado,
    onResetForm,
    resultados,
    dataSorteios,
    products,
  } = props;

  return (
    <>
      <Form
        form={form}
        formId="resultado-de-sorteios"
        initialValues={{ produto: "", titulo: "", tipoDeBusca: "produto" }}
        validationSchema={() => ({
          produto: Yup.object()
            .shape({
              label: Yup.string().required(),
              value: Yup.number().required(),
            })
            .test("produtosValidos", "Esse produto não é válido", (produto) => {
              const { value: productValue } = { ...produto };

              return (
                produto && products.find(({ value }) => productValue === value)
              );
            }),
          titulo: Yup.string().when("tipoDeBusca", {
            is: (tipoDeBusca) => tipoDeBusca === "titulo",
            then: Yup.string().min(14, "O título deve ter 14 dígitos"),
          }),
          tipoDeBusca: Yup.string(),
        })}
        formProps={{ ...props, resultados, dataSorteios }}
        onSubmit={buscarResultado}
        onResetForm={onResetForm}
      />
    </>
  );
};

ResultadoDeSorteiosForm.propTypes = {
  form: PropTypes.elementType.isRequired,
  buscarResultado: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  resultados: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  dataSorteios: PropTypes.arrayOf(PropTypes.string),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

ResultadoDeSorteiosForm.defaultProps = {
  resultados: [],
  dataSorteios: [],
};
export default ResultadoDeSorteiosForm;
